import { Component, OnInit, ComponentFactoryResolver, Input } from '@angular/core';
import { FeeDataEntity } from 'src/app/models/data-entities';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-fee-data-entity-view',
    templateUrl: './fee-data-entity-view.component.html',
    styleUrls: ['./fee-data-entity-view.component.css'],
    standalone: false
})
export class FeeDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
    templateForPermitForm:boolean=false

  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context : WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
         //added by priya 22-12-2025
              layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
         //end by priya 22-12-2025

  }

  entity: FeeDataEntity;

  modelValue: number;

  ngOnInit() {
    const value = parseFloat(this.entity.formulaValue);
    if (isNaN(value)) {
      this.modelValue = 0;
    } else {
      this.modelValue = value;
    }
  }
}
